import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {ComponentController} from "../../infrastructure/controllers/component-controller";
import {ACTION_TYPES} from "../consts";

export class BaseQueryChangeHandler extends ActionHandler {
  controller: ComponentController;
  type = ACTION_TYPES.changeQuery;

  static injectables = [...ActionHandler.injectables];

  action(params) {
    this.state.query = params.query;
  }
}
